// @flow

import type { UiPopup } from 'redux/type/uiPopup'

import React from 'react'
import styles from './Error.scss'
import error from './images/error.png'

export default class extends React.PureComponent<{
  uiPopup: UiPopup
}> {
  render () {
    let { message } = this.props.uiPopup
    return (
      <div className={styles.this}>
        <div className={styles.mintIndicatorWrapper}>
          <span className={styles.mintIndicatorSpin}>
            <img src={error} />
          </span>
          {message && (
            <span className={styles.mintIndicatorText}>{message}</span>
          )}
        </div>
        <div className={styles.shade} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/frame/ui/popup/Error.js